import {
  useAppSimpleFilterSelectedValue,
  useFilterSelectionMemo,
} from './common.hook';
import { FILTER_NAMES } from './filter-names.constants';

export const useFilterComparisonPeriodsSelection = () => {
  const datePrev = useAppSimpleFilterSelectedValue(FILTER_NAMES.DATEPREV);
  const datePost = useAppSimpleFilterSelectedValue(FILTER_NAMES.DATEPOST);
  const prodHier = useAppSimpleFilterSelectedValue(FILTER_NAMES.PRODUCTHIER);

  const filterSelection = useFilterSelectionMemo(datePrev, datePost, prodHier);
  return filterSelection;
};
